import styled from 'styled-components';
import { Box } from 'reflexbox/styled-components';

const NotFullColumn = styled(Box).attrs({ mx: 'auto', width: [1, 5/6, 2/3] })``;

export default NotFullColumn;
